import { useContext, useEffect, useState } from 'react';
import { gql } from '@apollo/client';

import { AppContext } from '../../App.context';

export function useAuth(args: AuthArgs): AuthResponse {
    const { credential } = args;
    const { apolloClient, appKey, rebuildApolloClient } = useContext(AppContext);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | null>(null);
    const [token, setToken] = useState<string>('');
    const [expiredAt, setExpiredAt] = useState<string>('')
    useEffect(() => {
        if (!credential) {
            return;
        }
        const props = {
            apolloClient,
            appKey,
            password: credential
        }
        setIsLoading(true);
        authenticate(props)
            .then((response) => {
                console.log(`RESPONSE:`, response);
                setToken(response.token);
                setExpiredAt(response.expiredAt);
                rebuildApolloClient();
            })
            .catch(err => {
                setError(err);
            })
            .finally(() => {
                setIsLoading(false);
            })
    }, [credential])

    return {
        token,
        expiredAt,
        isLoading,
        error,
    }
}

interface AuthArgs {
    credential: string;
}

interface AuthResponse {
    token: string;
    expiredAt: string;
    isLoading: boolean;
    error: Error | null;
}

async function authenticate(args: AuthenticateAdminArgs) {
    const { apolloClient, password, appKey } = args;
    const result = await apolloClient.query({
        query: AUTHENTICATE_ADMIN,
        fetchPolicy: 'no-cache',
        headers: {
            'app-key': appKey,
        },
        variables: {
            password
        }
    });
    const { authenticateAdmin } = result.data;
    return authenticateAdmin;
}

interface AuthenticateAdminArgs {
    appKey: string;
    apolloClient: any;
    password: any;
}


export const AUTHENTICATE_ADMIN = gql`
  query AuthenticateAdmin($password: String!) {
    authenticateAdmin(password: $password) {
      token
      expiredAt
    }
  }
`